import { Routes } from "@angular/router";

import { AuthShell, MainShell } from "@shell";

// Main
import { ROUTES as HOME_ROUTES } from "./features/home/routes";
//import { ROUTES as PERFIL_ROUTES } from "./features/perfil/routes";
import { ROUTES as ACTUALIZAR_CLAVE_ROUTES } from "./features/actualizar-clave/routes";
import { ROUTES as CATOLOGO_ROUTES } from "./features/catalogo/routes";

// Auth
import { ROUTES as LOGIN_ROUTES } from "./features/login/routes";
import { ROUTES as RECUPERAR_CLAVE_ROUTES } from "./features/recuperar-clave/routes";
import { ROUTES as CAMBIAR_CLAVE_ROUTES } from "./features/cambiar-clave/routes";

// Admin
import { ROUTES as USUARIO_ROUTES } from "./features/usuario/routes";
import { ROUTES as USUARIO_APP_ROUTES } from "./features/usuario-app/routes";
//import { ROUTES as ALERTA_ROUTES } from "./features/alerta/routes";
import { ROUTES as REPORTE_ROUTES } from "./features/reporte/routes";
import { ROUTES as ROLES_ROUTES } from "./features/rol/routes";
import { ROUTES as HORARIO_ROUTES } from "./features/horario/routes";
import { ROUTES as MASCOTA_ROUTES } from "./features/mascota/routes";
import { ROUTES as MASCOTA_UPDATE_ROUTES } from "./features/mascota-update/routes";
import { ROUTES as ANUNCIO_ROUTES } from "./features/anuncio/routes";
import { ROUTES as PREGUNTA_ROUTES } from "./features/pregunta-frecuente/routes";
import { ROUTES as VIDEOTECA_ROUTES } from "./features/videoteca/routes";
import { ROUTES as PERDIDO_ROUTES } from "./features/perdido/routes";
import { ROUTES as ENCONTRADO_ROUTES } from "./features/encontrado/routes";
import { ROUTES as ADOPCION_ROUTES } from "./features/adopcion/routes";
import { ROUTES as PAREJA_ROUTES } from "./features/pareja/routes";
import { ROUTES as FORMULARIO_ROUTES } from "./features/formulario/routes";
import { ROUTES as NOTIFICACION_ROUTES } from "./features/notificacion/routes";
import { ROUTES as ESPECIE_ROUTES } from "./features/especie/routes";

export const routes: Routes = [
  // Main
  MainShell.childRoutes([
    ...HOME_ROUTES,
    ...ACTUALIZAR_CLAVE_ROUTES,

    //ADMIN
    ...CATOLOGO_ROUTES,
    ...USUARIO_ROUTES,
    //...ALERTA_ROUTES,
    ...REPORTE_ROUTES,
    ...ROLES_ROUTES,
    ...USUARIO_APP_ROUTES,
    ...HORARIO_ROUTES,
    ...MASCOTA_ROUTES,
    ...ANUNCIO_ROUTES,
    ...PREGUNTA_ROUTES,
    ...MASCOTA_UPDATE_ROUTES,
    ...VIDEOTECA_ROUTES,
    ...PERDIDO_ROUTES,
    ...ENCONTRADO_ROUTES,
    ...ADOPCION_ROUTES,
    ...PAREJA_ROUTES,
    ...FORMULARIO_ROUTES,
    ...NOTIFICACION_ROUTES,
    ...ESPECIE_ROUTES
  ]),

  // Auth
  AuthShell.childRoutes([...LOGIN_ROUTES ]),

  // recuperar
  ...RECUPERAR_CLAVE_ROUTES,
  ...CAMBIAR_CLAVE_ROUTES,

  { path: "**", redirectTo: "/", pathMatch: "full" },
];
